module.exports = __webpack_public_path__ + "static/media/v1-assignees.02ae9e2b.gif";